import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/account-supplier`;

export const supplierService = {
    getRetailers: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-retailer-relations`,{
            params
        })
        .then((response) => {
            return response.data;
        });

    },
    lookupRetailers: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/lookup-retailers`,{
            params
        })
        .then((response) => {
            return response.data;
        });

    },
    getRetailerRelationRequests: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/retailer-relation-requests`,{
            params
        })
        .then((response) => {
            return response.data;
        });

    },
    createRetailerRelationRequest: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/retailer-relation-request`, params)
        .then((response) => {
            return response.data;
        });
    },
    withdrawRetailerRelationRequest: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/withdraw-retailer-relation-request`, params)
        .then((response) => {
            return response.data;
        });
    },
}